
define("login.en-GB", function(){});
